"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useZaps = exports.isZapOn = exports.isZapOff = void 0;
const lodash_1 = require("lodash");
const useZaps_1 = __importDefault(require("../zaps/useZaps"));
const isZapOff_1 = __importDefault(require("./isZapOff"));
const isZapOn_1 = __importDefault(require("./isZapOn"));
const opaqueZapConversions_1 = require("./opaqueZapConversions");
function isZapOff(zap) {
    return isZapOff_1.default(opaqueZapConversions_1.toInternalZap(zap));
}
exports.isZapOff = isZapOff;
function isZapOn(zap) {
    return isZapOn_1.default(opaqueZapConversions_1.toInternalZap(zap));
}
exports.isZapOn = isZapOn;
function useZaps(accountId) {
    const { isLoading, zaps } = useZaps_1.default(accountId);
    return {
        isLoading,
        zaps: lodash_1.mapValues(zaps, opaqueZapConversions_1.toOpaqueZap),
    };
}
exports.useZaps = useZaps;
